import React, { FC, useEffect, useState } from "react";
import { IUploadReferral } from "../../../interfaces/IReferral";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import {
  fetchSchemeById,
  getClaimSubmission,
  resetLocalFiles,
  saveChanges,
  setToggleEditMode,
  setUploadedDocumentUrl,
  submitClaimSubmission,
  submitClaimSubmissionToEdgePro,
  toggleEditMode,
  updateClaimSubmission,
  updateField,
  UploadDocument,
} from "../../../models/preAuthClaimSlice";
import { IDocumentFields } from "../../../interfaces/ICase";
import { errorMessage, successMessage } from "../../../utils/notificationUtils";
import {
  PreAuthClaimField,
  PreAuthClaimResponse,
  PreAuthClaimSection,
} from "../../../interfaces/IPreAuthClaim";
import { message } from "antd";
import FilePreviewModal from "../../../components/patient/PreAuth-query/FilePreviewModal";
import { getPortalData, resetPortalData } from "../../../models/preAuthSlice";
import dayjs from "dayjs";
import PreAuthClaimIhx from "../../../components/patient/PreAuthClaim/PreAuthClaimIhx";
import RightSidePreviewModal from "../../../components/modals/RightSidePreviewModal";
import {
  deleteUploadedDocument,
  downloadDocument,
  submitApproval,
} from "../../../apis/patientService";
import {
  clearDeficiencyCheck,
  getDeficiencyQuestionData,
  getDeficiencyQuestions,
  updateDocuments,
} from "../../../models/patientSlice";
import DocumentDeficiencyModal from "../../../components/patient/DocumentDeficiencyModal";
import { debug } from "console";

type PreAuthClaimContainerProps = {
  claimId: string | null;
  onfetchStepper: () => void; // Define prop type for the function
  stepperForStatus: CallableFunction;
  nextStage: any;
  setMoveToNext: CallableFunction;
};

export interface preAuthClaimSection {
  [key: string]: PreAuthClaimField[];
}

const PreAuthClaimContainerIhx: FC<PreAuthClaimContainerProps> = (props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false); //to open a modal of preview
  const { patients, auth, hospital, preAuthClaim, preAuth } = useSelector(
    (state: RootState) => state
  );
  const [selectedFile, setSelectedFile] = useState<IUploadReferral>({
    file: {},
    documentType: "",
  });
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const [previewDocument, setPreviewDocument] = useState(false);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [newClaimId, setNewClaimId] = useState<string | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [portalSubmission, setPortalSubmission] = useState<string | null>(null);
  const [caseClaimSubmissionId, setCaseClaimSubmissionId] = useState<
    number | null
  >(null);
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(
    null
  ); //to send document id for deficiency check
  const [documentName, setDocumentName] = useState("");
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [isDownloadingDocument, setIsDownloadingDocument] = useState<boolean>(false);
  const [downloadingDocumentUrl, setDownloadingDocumentUrl] = useState<string>("");

  const handleCancel = () => {
    setUploadFileModal(false);
  };

  const viewFile = (file: any) => {
    window.open(file, "_blank");
  };
  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };
  const handleSetDocumentUrl = (url: string) => {
    setDocumentUrl(url);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedDocumentId) {
          dispatch(clearDeficiencyCheck());
          // const firstRes = await dispatch(getDeficiencyQuestions(selectedDocumentId));

          if (selectedDocument?.id) {
            const secondRes = await dispatch(
              getDeficiencyQuestionData(selectedDocument?.id)
            );
          }
        }
      } catch (err) {
        errorMessage("Please, Try again after sometime");
        setSelectedDocumentId(null);
        setSelectedDocument(null);
      }
    };

    if (selectedDocumentId || selectedDocument?.id) fetchData();
  }, [selectedDocumentId, selectedDocument?.id]);

  const handleDeficiencyModalOpen = (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeficiencyModalAfterSave = (
    documentUrl: string,
    documentId: number,
    field: any
  ) => {
    const document = {
      id: field?.documentId,
      documentName: field?.documentName,
      documentType: field?.labelId,
      documentUrl: field?.data,
      documentLabelType: field?.label,
      deficiencyCheckStatus: field?.deficiencyCheckStatus,
    };
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocumentId(null);
    setSelectedDocument(null);
  };

  useEffect(() => {
    if (
      preAuthClaim &&
      preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses
    ) {
      const preAuthClaimRes = preAuthClaim.preAuthClaimRes;
      const initialEditedFields: Record<string, Record<string, string>> = {};
      Object.keys(preAuthClaim?.preAuthClaimRes)?.forEach((key) => {
        const sections = preAuthClaimRes[key as keyof PreAuthClaimResponse] as
          | PreAuthClaimSection[]
          | undefined;
        if (sections) {
          sections?.forEach((section) => {
            Object.entries(section)?.forEach(([sectionTitle, fields]) => {
              if (Array.isArray(fields)) {
                fields?.forEach((field: PreAuthClaimField) => {
                  if (!initialEditedFields[key]) {
                    initialEditedFields[key] = {};
                  }
                  initialEditedFields[key][field.id] = field.data ?? "";
                });
              }
            });
          });
        }
      });
      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
    }
  }, [caseClaimSubmissionId, preAuthClaim?.preAuthClaimRes]);

  const handleDeleteList = async (
    docType: string,
    documentUrl: string,
    idx: number
  ) => {
    const deleteDocument = preAuthClaim?.uploadedDocumentUrl?.find(
      (doc, index) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    const newUpdatedDocumentList = preAuthClaim?.uploadedDocumentUrl?.filter(
      (doc, index) => doc?.documentUrl !== documentUrl
    );
    dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));
    if (deleteDocument?.documentUrl) {
      const res = await deleteUploadedDocument(deleteForm);

      if (res) {
        if (preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses) {
          if (
            docType?.toUpperCase() === "OTHERS" ||
            docType?.toUpperCase() === "Discharge Summary"?.toUpperCase() ||
            docType?.toUpperCase() === "Final Bill"?.toUpperCase() ||
            docType?.toUpperCase() === "Invoice"?.toUpperCase() ||
            docType?.toUpperCase() === "CKYC Form"?.toUpperCase() ||
            docType?.toUpperCase() === "Proposer PAN Card"?.toUpperCase() ||
            docType?.toUpperCase() === "Proposer ID Proof"?.toUpperCase() ||
            docType?.toUpperCase() === "Patient ID Proof"?.toUpperCase() ||
            docType?.toUpperCase() === "Insurance Card"?.toUpperCase() ||
            docType?.toUpperCase() === "Preauth form"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "All investigation reports mentioned in final bill break up(Xray,ECG.EEG,Biopsy,Lab reports,MRI Etc)"?.toUpperCase() ||
            docType?.toUpperCase() ===
              "Investigation reports and ICP if available"?.toUpperCase()
          ) {
            const hasDocument = newUpdatedDocumentList?.some(
              (doc) =>
                doc?.documentLabelType?.toUpperCase() === docType?.toUpperCase()
            );
            if (!hasDocument) {
              dispatch(
                updateField({
                  sectionKey: "ihxClaimSubmissionResponses",
                  fieldId: docType?.split(" ").join("_"),
                  value: "",
                })
              );
            }
          } else {
            dispatch(
              updateField({
                sectionKey: "ihxClaimSubmissionResponses",
                fieldId: docType?.split(" ").join("_"),
                value: "",
              })
            );
          }
        }
        // getClaimSubmissionData();
      }
    }
  };

  // const handleDeleteList = async (docType: any, documentUrl: string, idx: number) => {
  //   const deleteDocument = preAuthClaim?.uploadedDocumentUrl?.find(
  //     (doc, index) => doc?.documentUrl === documentUrl
  //   );
  //   const deleteFormOld = {
  //     documentUrl: deleteDocument?.documentUrl,
  //     status: false,
  //     id: deleteDocument?.id,
  //   };

  //   const newUpdatedDocumentList = preAuthClaim?.uploadedDocumentUrl?.filter(
  //     (doc: any, index: number) => doc?.documentUrl === documentUrl
  //   );
  //   dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));
  //   dispatch(
  //     updateField({
  //       sectionKey: "ihxClaimSubmissionResponses",
  //       fieldId: docType?.split(" ").join("_"),
  //       value: "",
  //     })
  //   );

  //   const deleteForm = {
  //     patientId: patients?.fetchBasicDetails?.patientResponse?.id,
  //     documentUrl: docType?.documentUrl,
  //     documentType: docType?.documentType,
  //     status: false,
  //     id: docType?.id,
  //   };
  //   dispatch(updateDocuments(deleteForm));
  // };

  const getClaimSubmissionData = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id &&
      preAuthClaim?.selectedScheme?.portalMetaDataIdsList
    ) {
      const resp = await dispatch(
        getClaimSubmission({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
        })
      );
      if (getClaimSubmission.rejected.match(resp)) {
        errorMessage("CAN NOT ADD CLAIM BEFORE INITIATE PREAUTH !");
      } else if (getClaimSubmission.fulfilled.match(resp)) {
        if (resp?.payload?.claimSubmissionRes) {
          getAttachmentsWithValues(resp?.payload?.claimSubmissionRes);
        }
      }
    }
  };

  useEffect(() => {
    getClaimSubmissionData();
    props?.stepperForStatus();

    const portalSubmitCheck =
      preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses?.[0]?.[
        "Basic Details"
      ]?.[0].status;
    if (
      preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses === undefined
    ) {
      setPortalSubmission(null); // check
    }
    if (portalSubmitCheck !== undefined) {
      setPortalSubmission(portalSubmitCheck);
    }
  }, [preAuthClaim?.selectedScheme?.portalMetaDataIdsList]);

  const getAttachmentsWithValues = (preAuthClaimData: PreAuthClaimResponse) => {
    const attachmentsWithValues: Array<IDocumentFields> = [];

    if (preAuthClaimData?.ihxClaimSubmissionResponses) {
      const attachments = preAuthClaimData?.ihxClaimSubmissionResponses?.[0]?.[
        "Document Details"
      ]?.filter(
        (doc) =>
          doc?.type === "document-upload" || doc?.type === "document-show"
      );
      attachments?.forEach((attachment) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
        // if (attachment?.data && attachment?.documentName) {
        //   attachmentsWithValues.push({
        //     documentName: attachment?.documentName,
        //     documentType: attachment?.labelId,
        //     documentUrl: attachment?.data,
        //     documentLabelType: attachment?.label,
        //     id: attachment?.documentId,
        //     deficiencyCheckStatus: attachment?.deficiencyCheckStatus,
        //     prefilledData: true,
        //   });
        // }
      });

      dispatch(setUploadedDocumentUrl(attachmentsWithValues));
    } else if (preAuthClaimData?.starHealthClaimSubmissionResponse) {
      const attachments =
        preAuthClaimData?.starHealthClaimSubmissionResponse?.[0]?.[
          "document"
        ]?.filter(
          (doc) =>
            doc?.type === "document-upload" || doc?.type === "document-show"
        );
      attachments?.forEach((attachment) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
      });

      dispatch(setUploadedDocumentUrl(attachmentsWithValues));
    }
  };

  useEffect(() => {
    const attachmentsWithValues: Array<IDocumentFields> = [];
    if (preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses) {
      // Update caseClaimSubmissionId with the new value
      const newCaseClaimSubmissionId =
        preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses?.[0]?.[
          "Basic Details"
        ]?.[0].caseClaimSubmissionId;
      if (newCaseClaimSubmissionId) {
        setCaseClaimSubmissionId(newCaseClaimSubmissionId);

        const portalSubmitCheck =
          preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses?.[0]?.[
            "Basic Details"
          ]?.[0].status;

        if (portalSubmitCheck) {
          setPortalSubmission(portalSubmitCheck);
        }
        const attachments =
          preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses?.[0]?.[
            "Document Details"
          ]?.filter(
            (doc) =>
              doc?.type === "document-upload" || doc?.type === "document-show"
          );
        attachments?.forEach((attachment) => {
          if (
            attachment?.documentsList &&
            attachment?.documentsList?.length > 0
          ) {
            attachment?.documentsList?.forEach((document) => {
              attachmentsWithValues.push({
                documentName: document?.documentName,
                documentType: document?.documentType,
                documentUrl: document?.documentUrl,
                id: document?.id,
                deficiencyCheckStatus: document?.deficiencyCheckStatus,
                documentLabelType: document?.documentLabelType,
              });
            });
          }
        });

        dispatch(setUploadedDocumentUrl(attachmentsWithValues));
        // dispatch(
        //   setUploadedDocumentUrl(
        //     preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses?.[0]?.[
        //       "Attachments"
        //     ]
        //   )
        // );
      } else {
        setCaseClaimSubmissionId(null);
      }
    } else {
      setCaseClaimSubmissionId(123);
    }
  }, [preAuthClaim?.preAuthClaimRes]);

  // useEffect(() => {
  //   if (preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses) {
  //     // Update caseClaimSubmissionId with the new value
  //     const newCaseClaimSubmissionId =
  //       preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses?.[0]?.[
  //         "Basic Details"
  //       ]?.[0].caseClaimSubmissionId;
  //     if (newCaseClaimSubmissionId) {
  //       setCaseClaimSubmissionId(newCaseClaimSubmissionId);

  //       const portalSubmitCheck =
  //         preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses?.[0]?.[
  //           "Basic Details"
  //         ]?.[0].status;

  //       if (portalSubmitCheck) {
  //         setPortalSubmission(portalSubmitCheck);
  //       }
  //       dispatch(
  //         setUploadedDocumentUrl(
  //           preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses?.[0]?.[
  //             "Attachments"
  //           ]
  //         )
  //       );
  //     } else {
  //       setCaseClaimSubmissionId(null);
  //     }
  //   } else {
  //     setCaseClaimSubmissionId(123);
  //   }
  // }, [preAuthClaim?.preAuthClaimRes]);

  useEffect(() => {
    if (!props?.claimId) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        dispatch(
          getPortalData({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      } else {
        dispatch(resetPortalData());
      }
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  useEffect(() => {
    if (!props?.claimId) {
      if (preAuth?.portalData) {
        const {
          casePreAuthEchs,
          casePreAuthIhx,
          casePreAuthCghs,
          casePreAuthStarhealth,
        } = preAuth.portalData;

        if (casePreAuthEchs?.casePreAuthEchsReferralResponse) {
          setNewClaimId(
            casePreAuthEchs.casePreAuthEchsReferralResponse.claimId || null
          );
        } else if (casePreAuthEchs?.casePreAuthEchsEmergencyResponse) {
          setNewClaimId(
            casePreAuthEchs.casePreAuthEchsEmergencyResponse.claimId || null
          );
        } else if (casePreAuthIhx) {
          setNewClaimId(casePreAuthIhx.claimId || null);
        } else if (casePreAuthCghs) {
          setNewClaimId(casePreAuthCghs.claimId || null);
        } else if (casePreAuthStarhealth) {
          setNewClaimId(casePreAuthStarhealth.claimId || null);
        } else {
          setNewClaimId(null);
        }
      } else {
        setNewClaimId(null);
      }
    }
  }, [preAuth?.portalData]);

  const updateOrAddDocument = (
    uploadedDocumentUrl: Array<IDocumentFields>,
    documentRes: IDocumentFields
  ): Array<IDocumentFields> => {
    const updatedDocuments = [...uploadedDocumentUrl];
    const documentIndex = updatedDocuments?.findIndex(
      (doc) => doc.documentType === documentRes.documentType
    );

    if (
      documentIndex !== -1 &&
      documentRes?.documentLabelType?.toUpperCase() !== "OTHERS" &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Discharge Summary"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Final Bill"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Invoice"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "CKYC Form"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Proposer PAN Card"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Proposer ID Proof"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Patient ID Proof"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Insurance Card"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Preauth form"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "All investigation reports mentioned in final bill break up(Xray,ECG.EEG,Biopsy,Lab reports,MRI Etc)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Investigation reports and ICP if available"?.toUpperCase()
    ) {
      updatedDocuments[documentIndex] = {
        ...updatedDocuments[documentIndex],
        documentName: documentRes.documentName,
        documentUrl: documentRes.documentUrl,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      };
    } else {
      updatedDocuments.push({
        documentType: documentRes.documentType,
        documentName: documentRes.documentName,
        documentUrl: documentRes.documentUrl,
        documentLabelType: documentRes?.documentLabelType,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      });
    }
    return updatedDocuments;
  };

  const handleUploadDocument = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    CollectPostData.append("documentType", selectedFile?.documentType);

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file?.originFileObj as Blob);
    }

    try {
      const resp = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      );

      if (UploadDocument.fulfilled.match(resp)) {
        const updatedDocuments = updateOrAddDocument(
          preAuthClaim?.uploadedDocumentUrl,
          resp?.payload
        );

        setSelectedFile({ file: {}, documentType: "" });
        if (resp?.payload?.documentUrl) {
          message.success(
            `${resp?.payload?.documentLabelType} HAS BEEN UPLOAD SUCCESSFULLY`
          );

          dispatch(setUploadedDocumentUrl(updatedDocuments));
        } else {
          message.error("Please Upload Again");
        }
        setUploadFileModal(false);
      } else if (UploadDocument.rejected.match(resp)) {
        errorMessage("FAILED TO GENERATE BILL");
      }
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };

  // check
  const handleFileChange = (documentType: string) => (e: any) => {
    const maxSize = 15 * 1024 * 1024;
    if (Array.isArray(e)) {
      return e;
    }
    // if (e?.file?.size > maxSize) {
    //   errorMessage("File Limit must be less than or equal to 15 MB");
    //   return;
    // }
    const length = e?.fileList?.length - 1;
    if (e?.fileList[0]) {
      setSelectedFile({ file: e?.fileList[length], documentType });
      setPreviewFile({
        url: URL.createObjectURL(e.file),
        name: e.file.name,
        showUpload: true,
        documentType: documentType,
      });
      setUploadFileModal(true);
    }
    return e?.fileList;
  };

  const handleFieldChange = (
    sectionKey: string,
    fieldId: string,
    value: string
  ) => {
    if (fieldId?.toLowerCase()?.includes("date")) {
      const currentDate = new Date();

      dispatch(
        updateField({
          sectionKey,
          fieldId,
          value: value,
          // value: dayjs(value, "DD-MM-YYYY HH:mm:ss"),
        })
      );
    } else {
      dispatch(updateField({ sectionKey, fieldId, value }));
    }
  };

  const formatDateFields = (response: any) => {
    return {
      ...response,
      // Format these date fields as "DD-MM-YYYY HH:mm:ss"
      dateOfAdmission: dayjs(response.dateOfAdmission).format(
        "DD-MM-YYYY HH:mm:ss"
      ),
      dateOfDischarge: dayjs(response.dateOfDischarge).format(
        "DD-MM-YYYY HH:mm:ss"
      ),
    };
  };

  const handleSaveChangesIhx = async () => {
    setIsSubmitted(true);
    let dataToSave: any = {};

    // Initialize documents array
    dataToSave.documents = [];

    // Check if ihxClaimSubmissionResponses exists and is an array
    if (preAuthClaim?.editedFields?.ihxClaimSubmissionResponses) {
      // Add ihxClaimSubmissionResponses to documents
      dataToSave = {
        ...dataToSave,
        additionalAmountPaid: false,
        claimNo: props?.claimId || newClaimId,
        status: true,
        ...preAuthClaim.editedFields.ihxClaimSubmissionResponses,
      };
      delete dataToSave.document;
      // Add uploadedDocumentUrl to documents if it exists

      if (caseClaimSubmissionId) {
        const formattedDocuments = preAuthClaim?.uploadedDocumentUrl?.map(
          (doc: any) => ({
            documentType: doc?.labelId,
            documentName: doc.documentName,
            documentUrl: doc.data,
            id: doc?.documentId,
          })
        );
        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = [...preAuthClaim?.uploadedDocumentUrl];
        }
      } else {
        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = [...preAuthClaim?.uploadedDocumentUrl];
        }
      }
    }

    // Convert "true"/"false" string values to boolean for specific fields
    if (typeof dataToSave.patientDischargeToday === "string") {
      dataToSave.patientDischargeToday =
        dataToSave.patientDischargeToday === "true";
    }

    if (typeof dataToSave.patientUtilizedPA === "string") {
      dataToSave.patientUtilizedPA = dataToSave.patientUtilizedPA === "true";
    }

    dataToSave["totalAmount"] =
      preAuthClaim.editedFields?.ihxClaimSubmissionResponses?.claimedAmount?.toString() ||
      null;

    if (!props?.claimId && !newClaimId) {
      errorMessage("Claim Id is not present");
      return;
    }

    const formattedResp = formatDateFields(dataToSave);

    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id &&
      preAuthClaim?.selectedScheme?.portalMetaDataIdsList
    ) {
      if (caseClaimSubmissionId === null) {
        const resp = await dispatch(
          submitClaimSubmission({
            data: dataToSave,
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
          })
        );

        if (submitClaimSubmission.fulfilled.match(resp)) {
          if (resp?.payload?.errorMessage) {
            errorMessage(resp?.payload?.errorMessage);
          } else {
            successMessage("CLAIM SUBMITTED SUCCESSFULLY");
            props?.onfetchStepper();
            dispatch(resetLocalFiles());
            getClaimSubmissionData();
            setIsEditable(false);
          }
        } else if (updateClaimSubmission.rejected.match(resp)) {
          if (resp?.error?.message) {
            errorMessage(resp?.error?.message);
            dispatch(resetLocalFiles());
          }
        }
      } else {
        const resp = await dispatch(
          updateClaimSubmission({
            data: dataToSave,
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
            caseClaimSubmissionId: caseClaimSubmissionId || 1,
          })
        );

        if (updateClaimSubmission.fulfilled.match(resp)) {
          if (resp?.payload?.errorMessage) {
            errorMessage(resp?.payload?.errorMessage);
          } else {
            successMessage("CLAIM HAS BEEN UPDATED SUCCESSFULLY");
            dispatch(resetLocalFiles());
            props?.onfetchStepper();
            getClaimSubmissionData();
            setIsEditable(false);
          }
        } else if (updateClaimSubmission.rejected.match(resp)) {
          if (resp?.error?.message) {
            errorMessage(resp?.error?.message);
            dispatch(resetLocalFiles());
          }
        }
      }
      dispatch(saveChanges());
      dispatch(setUploadedDocumentUrl([]));
    }
  };
  const handleSaveToEdgeProChangesIhx = async () => {
    setIsSubmitted(true);
    let dataToSave: any = {};

    // Initialize documents array
    dataToSave.documents = [];

    // Check if ihxClaimSubmissionResponses exists and is an array
    if (preAuthClaim?.editedFields?.ihxClaimSubmissionResponses) {
      // Add ihxClaimSubmissionResponses to documents
      dataToSave = {
        ...dataToSave,
        additionalAmountPaid: false,
        claimNo: props?.claimId || newClaimId,
        status: true,
        ...preAuthClaim.editedFields.ihxClaimSubmissionResponses,
      };
      delete dataToSave.document;
      // Add uploadedDocumentUrl to documents if it exists

      if (caseClaimSubmissionId) {
        const formattedDocuments = preAuthClaim?.uploadedDocumentUrl?.map(
          (doc: any) => ({
            documentType: doc.documentLabelType,
            documentName: doc.documentName,
            documentUrl: doc.data,
            id: doc?.documentId,
          })
        );
        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = [...preAuthClaim?.uploadedDocumentUrl];
        }
      } else {
        if (preAuthClaim?.uploadedDocumentUrl) {
          dataToSave.documents = [...preAuthClaim?.uploadedDocumentUrl];
        }
      }
    }

    // Convert "true"/"false" string values to boolean for specific fields
    if (typeof dataToSave.patientDischargeToday === "string") {
      dataToSave.patientDischargeToday =
        dataToSave.patientDischargeToday === "true";
    }

    if (typeof dataToSave.patientUtilizedPA === "string") {
      dataToSave.patientUtilizedPA = dataToSave.patientUtilizedPA === "true";
    }

    dataToSave["totalAmount"] =
      preAuthClaim.editedFields?.ihxClaimSubmissionResponses?.claimedAmount?.toString() ||
      null;

    // if (!props?.claimId && !newClaimId) {
    //   errorMessage("Claim Id is not present");
    //   return;
    // }

    const formattedResp = formatDateFields(dataToSave);

    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id &&
      preAuthClaim?.selectedScheme?.portalMetaDataIdsList
    ) {
      const resp = await dispatch(
        submitClaimSubmissionToEdgePro({
          data: dataToSave,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          portalId: preAuthClaim?.selectedScheme?.portalMetaDataIdsList[0],
          // caseClaimId: null
          caseClaimId: caseClaimSubmissionId || null,
        })
      );

      if (submitClaimSubmissionToEdgePro.fulfilled.match(resp)) {
        if (resp?.payload?.errorMessage) {
          errorMessage(resp?.payload?.errorMessage);
        } else {
          successMessage("CLAIM HAS BEEN SAVED SUCCESSFULLY");
          dispatch(resetLocalFiles());
          getClaimSubmissionData();
          props?.onfetchStepper();
          setIsEditable(false);
        }
      } else if (submitClaimSubmissionToEdgePro.rejected.match(resp)) {
        errorMessage("CLAIM HAS NOT BEEN SAVED, PLEASE, TRY AGAIN");
        dispatch(resetLocalFiles());
      }

      dispatch(saveChanges());
      dispatch(setUploadedDocumentUrl([]));
    }
  };

  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
      dispatch(
        fetchSchemeById(
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        )
      );
    }
  }, [patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId]);

  useEffect(() => {
    preAuthClaim?.uploadedDocumentUrl?.forEach((doc: any) =>
      dispatch(
        updateField({
          sectionKey: "ihxClaimSubmissionResponses",
          fieldId: doc?.documentLabelType?.split(" ").join("_"),
          value: doc?.documentUrl,
        })
      )
    );
  }, [preAuthClaim?.uploadedDocumentUrl]);

  useEffect(() => {
    dispatch(setUploadedDocumentUrl([]));
  }, []);

  const handleEditable = () => {
    if (!isEditable && preAuthClaim && preAuthClaim?.preAuthClaimRes) {
      const preAuthClaimRes = preAuthClaim.preAuthClaimRes;

      const initialEditedFields: Record<string, Record<string, any>> = {};
      Object.keys(preAuthClaim?.preAuthClaimRes)?.forEach((key) => {
        const sections = preAuthClaimRes[key as keyof PreAuthClaimResponse] as
          | PreAuthClaimSection[]
          | undefined;
        if (sections) {
          sections?.forEach((section) => {
            Object?.entries(section)?.forEach(([sectionTitle, fields]) => {
              if (Array.isArray(fields)) {
                fields?.forEach((field: PreAuthClaimField) => {
                  if (!initialEditedFields[key]) {
                    initialEditedFields[key] = {};
                  }

                  if (
                    preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses
                  ) {
                    initialEditedFields[key][field.id] = field.data ?? "";
                    if (field.type === "document-show") {
                      initialEditedFields[key][field.id] = [
                        {
                          documentUrl: field?.data ?? "",
                          documentType: field?.labelId,
                          documentName: field?.documentName ?? "",
                        },
                      ];
                    }
                  }
                });
              }
            });
          });
        }
      });

      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
    }
    setIsEditable(!isEditable);
  };
  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      setIsDownloadingDocument(true);
      setDownloadingDocumentUrl(url);
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
      setIsDownloadingDocument(false);
      setDownloadingDocumentUrl("");
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    }
  };

  const handleOpen = () => {
    setPreviewDocument(true);
  };

  const [isApproved, setIsApproved] = useState<any>(false);
  const [isApprovedInitiated, setIsApprovedInitiated] =
    useState<boolean>(false);

  useEffect(() => {
    if (preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses) {
      setIsApproved(
        preAuthClaim?.preAuthClaimRes?.ihxClaimSubmissionResponses[0]?.[
          "approved"
        ]
      );
    }
  }, [preAuthClaim?.preAuthClaimRes]);

  const handleApprove = async () => {
    try {
      setIsApprovedInitiated(true);
      const formData = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        stage: "Claim",
        approved: true,
      };
      const res = await submitApproval(formData);
      setIsApproved(true);
      setIsApprovedInitiated(false);
    } catch (err) {
      errorMessage("Please, Try again later");
      setIsApprovedInitiated(false);
      setIsApproved(false);
    }
  };

  // useEffect(() => {
  //   if (preAuthClaim && caseClaimSubmissionId === null) {
  //     const initialEditedFields: Record<string, Record<string, any>> = {};
  //     Object.keys(preAuthClaim)?.forEach((key) => {
  //       const sections = preAuthClaim[key as keyof PreAuthClaimResponse] as
  //         | PreAuthClaimSection[]
  //         | undefined;
  //       if (sections) {
  //         sections?.forEach((section) => {
  //           Object.entries(section)?.forEach(([sectionTitle, fields]) => {
  //             if (Array.isArray(fields)) {
  //               fields?.forEach((field: PreAuthClaimField) => {
  //                 if (!initialEditedFields[key]) {
  //                   initialEditedFields[key] = {};
  //                 }
  //                 initialEditedFields[key][field.id] = field.data ?? null;
  //               });
  //             }
  //           });
  //         });
  //       }
  //     });
  //     dispatch(
  //       updateField({
  //         sectionKey: "all",
  //         fieldId: "all",
  //         value: initialEditedFields,
  //       })
  //     );
  //     dispatch(setToggleEditMode(true));
  //   } else {
  //     dispatch(setToggleEditMode(false));
  //   }
  // }, [caseClaimSubmissionId, preAuthClaim]);

  return (
    <div>
      <PreAuthClaimIhx
        handleFileChange={handleFileChange}
        uploadFileModal={uploadFileModal}
        selectedFile={selectedFile}
        handleCancel={handleCancel}
        handleUploadDocument={handleUploadDocument}
        viewFile={viewFile}
        handleDeleteList={handleDeleteList}
        preAuthClaimData={preAuthClaim?.preAuthClaimRes}
        caseClaimSubmissionId={caseClaimSubmissionId}
        editedFields={preAuthClaim?.editedFields}
        onFieldChange={handleFieldChange}
        visitType={patients?.fetchBasicDetails?.visitInfoResponse?.visitType}
        uploadedDocumentUrl={preAuthClaim?.uploadedDocumentUrl}
        handleSaveChangesIhx={handleSaveChangesIhx}
        handleSaveToEdgeProChangesIhx={handleSaveToEdgeProChangesIhx}
        isLoading={preAuthClaim?.isSubmit}
        isEditable={isEditable}
        handleEditable={handleEditable}
        handleSetDocumentUrl={handleSetDocumentUrl}
        handleOpen={handleOpen}
        handleDownloadDocument={handleDownloadDocument}
        isDownloadingDocument={isDownloadingDocument}
        downloadingDocumentUrl={downloadingDocumentUrl}
        isSubmitted={isSubmitted}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        previewDocumentUrl={previewDocumentUrl}
        setDocumentName={setDocumentName}
        handleDeficiencyModalAfterSave={handleDeficiencyModalAfterSave}
        portalSubmission={portalSubmission}
        nextStage={props?.nextStage}
        setMoveToNext={props?.setMoveToNext}
        handleApprove={handleApprove}
        isApproved={isApproved}
        isApprovedInitiated={isApprovedInitiated}
      />
      <FilePreviewModal
        isVisible={uploadFileModal}
        onClose={handleCancel}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUploadDocument}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.uid || "no-file"}
        isLoading={preAuthClaim?.isLoading}
      />
      <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocument}
      />
      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        isDownloadingDocument={isDownloadingDocument}
        downloadingDocumentUrl={downloadingDocumentUrl}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        type={"claim"}
      />
    </div>
  );
};

export default PreAuthClaimContainerIhx;
